/** @flow */

export default {
  LAST_NAME: "lastName",
  DATE_OF_BIRTH: "dateOfBirth",
  EMPLOYEE_REF_PRIMARY: "employeeRefPrimary",
  HOME_MOBILE: "homeMobile",
};
